import React from 'react';
import { defaultNumericColumnRenderer, numericDeltaColumnRenderer, } from './column-renderers';
export function makeDeltaColumnProps(props) {
    props = makeHiddenTitleColumnProps(props);
    return {
        ...props,
        align: 'left',
        render: numericDeltaColumnRenderer,
    };
}
export function makeNumberColumnProps(props) {
    return {
        ...props,
        align: 'right',
        render: defaultNumericColumnRenderer,
    };
}
export function makeHiddenTitleColumnProps(props) {
    return {
        ...props,
        title: (React.createElement("span", { style: { visibility: 'hidden' } }, props?.title ?? '')),
    };
}
